import styleInject from '../../../../common/temp/pnpm_store/.pnpm/style-inject@0.3.0/pnpm_store/style-inject/dist/style-inject.es.js';

var css_248z = ".select-list_icon__2ojD5,\n.select-list_select-item-icon__3iSiM {\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n.select-list_icon__2ojD5 > *,\n.select-list_select-item-icon__3iSiM > * {\n  width: 100%;\n  height: 100%;\n  background-size: contain;\n  display: inline-block;\n}\n.select-list_select-item-icon__3iSiM {\n  height: 20px;\n  width: 20px;\n}\n";
var styles = {"icon":"select-list_icon__2ojD5","select-item-icon":"select-list_select-item-icon__3iSiM"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=select-list.less.js.map
